import React from 'react';
import { Ui }from '@einstein/schedule-platform';

import {
  Section,
  Container,
  Wrapper,
  TextContainer,
  Title,
  Description,
  ButtonContainer,
  ImageSection
} from './styles';

const Image2x =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/EinsteinScheduling/image@3x.png';

type EinsteinSchedulingProps = {
  handleSchedule: () => void;
  hasProductError?: boolean;
};

const EinsteinScheduling = ({
  handleSchedule,
  hasProductError
}: EinsteinSchedulingProps) => {
  return (
    <Section>
      <Container>
        <Wrapper>
          <TextContainer>
            <Title>Agendamento Einstein</Title>
            <Description>
              Agende on-line suas consultas da Equipe de Cuidado e a vacina da
              gripe com muita facilidade.
            </Description>
            <ButtonContainer>
              <Ui.Button
                title={
                  !hasProductError ? 'Agendar' : 'Agendamento não disponível'
                }
                disabled={!!hasProductError}
                onClick={handleSchedule}
              />
            </ButtonContainer>
          </TextContainer>
          <ImageSection src={Image2x} />
        </Wrapper>
      </Container>
    </Section>
  );
};

export default EinsteinScheduling;
